import type { FunctionComponent } from 'react';
import { useSchoolPageBySlugQuery } from '../../../../graphql/useSchoolPageBySlugQuery';
import { SchoolTitle } from './SchoolTitle';

export const SchoolTitleWithData: FunctionComponent = () => {
  const { data } = useSchoolPageBySlugQuery();
  const pageTitleByParts = data?.schoolPageBySlug?.pageTitleByParts;
  if (!pageTitleByParts) return null;

  const { part1, part2 } = pageTitleByParts;
  return <SchoolTitle part1={part1} part2={part2} />;
};
